import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function TimelineItemContainer({
  date,
  title,
  side,
  isFirst,
  children,
  footer,
}) {
  const container = cx('m-timeline-1__item', `m-timeline-1__item--${side}`, {
    'm-timeline-1__item--first': isFirst,
  });

  return (
    <div className={container}>
      <div className="m-timeline-1__item-circle">
        <div className="m--bg-danger" />
      </div>
      <div className="m-timeline-1__item-arrow" />
      <span className="m-timeline-1__item-time m--font-dynamic">{date}</span>
      <div className="m-timeline-1__item-content">
        <div className="m-timeline-1__item-title">{title}</div>
        <div className="m-timeline-1__item-body">
          <div className="m-timeline-1__item-body m--margin-top-15">
            {children}
          </div>
        </div>
        {footer}
      </div>
    </div>
  );
}

TimelineItemContainer.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  side: PropTypes.oneOf(['left', 'right']).isRequired,
  isFirst: PropTypes.bool.isRequired,
  footer: PropTypes.node,
};

TimelineItemContainer.defaultProps = {
  footer: null,
};
